export const to = (p: Promise<any>): Promise<any[]> => p.then((data: any) => [null, data]).catch(err => [err]);

/**
 * 获取错误msg
 * @param  {[type]} err [description]
 * @return {[type]}     [description]
 */
export function getErrMsg(err) {
  let errMsg: any = 'unkonw error';
  if (typeof err === 'string' || typeof err === 'number') {
    // 对于字符串类型的错误
    errMsg = err;
  } else if (err && err.message) {
    // 对于标准错误，或者自定义的异常
    errMsg = err.message;
  } else if (err && err.stack) {
    // 对于标准错误
    errMsg = err.message;
  } else if (typeof err === 'object') {
    // 对于返回的object异常
    try {
      // errMsg = JSON.stringify(err);
    } catch (err) {
      errMsg = 'circled json';
    }
  }
  return errMsg;
}
